import dayjs from 'dayjs';
import React, {Fragment, useEffect, useState} from 'react';
import {Dialog, Transition} from "@headlessui/react";
import RetryButton from 'src/components/RetryButton';
// import SearchableSingleSelect from 'src/components/SearchableSingleSelect';
import Table from 'src/components/TableXHR';
import {toPersianDigit} from 'src/helpers/utils';
import arbaeenService from 'src/services/arbaeen.service';
import axios from 'axios';
import {EERRORS} from 'src/constants/errors.enum';
// import InquiryRequestButton from './InquiryRequestButton';
import Filter from "./Filter";
import fsServices from "../../../services/fs.service";


const initialAddInqueryResponse = {
  birthDate: '',
  departureDate: '',
  departureDestinationBorder: '',
  departureOriginCity: '',
  departureOriginProvince: '',
  departureType: '',
  dosesCount: 0,
  fatherName: '',
  firstName: '',
  gender: '',
  hasCovid: false,
  hasPassport: true,
  lastDose: 0,
  lastDoseDate: null,
  lastName: '',
  lastTestResult: '',
  lastTestResultDate: null,
  mobileNumber: '',
  nationalId: '',
  passportExpirationDate: '',
  passportNumber: '',
  qrCode: null,
  returnDate: '',
  returnDestinationCity: '',
  returnDestinationProvince: '',
  returnOriginBorder: '',
  returnType: '',
};

const pageSize = 10;
const PilogrimListWithFiltering: React.FC<{}> = () => {
  const [provinceOptions, setProvinceOptions] = useState<Array<{ label: string; value: string; id: any }>>([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dataSet, setDataSet] = useState<any>([]);
  const [error, setError] = useState<any>(null);

  const [query, setQuery] = useState({
    name: null,
    nationalId: null,
    mobileNumber: null,
    departureOriginProvince: null,
    departureDestinationBorder: null,
    // locked: null,
    currentPage: 1,
    retry: false,
    pageSize,
  });


  const getProvince = async () => {
    try {
      const normalizedData: any[] = [];
      const {data} = (await fsServices.getProvince()) as any;
      data.sort((a: any, b: any) => a.province.localeCompare(b.province, 'fa'));

      data.forEach((item: any) => {
        normalizedData.push({
          label: item.province,
          value: item.province,
          id: item.provinceCode,
        });
      });
      setProvinceOptions([...normalizedData]);
    } catch (e: any) {
      console.log(e);
    }
  };

  useEffect(() => {
    getProvince();
  }, []);

  const {CancelToken} = axios;
  const source = CancelToken.source();
  const getIt = async ({retry, currentPage, ...params}: any) => {
    const newData = {
      ...params,
      pageNumber: Number(query.currentPage) - 1,
    };
    setLoading(true);
    setError(null);
    try {
      const {data} = await arbaeenService.getPiligrimListV2(newData, {cancelToken: source.token});
      const normalizedData: any[] = [];
      data.content.forEach((item: any, index: number) => {
        normalizedData.push({
          id: `ovca_${index}`,
          pilgrimName: `${item.firstName || '-'} ${item.lastName || '-'}`,
          nationalId: item.nationalId || '',
          exitBorder: item.departureDestinationBorder || 'نامشخص',
          dateOfDispatch: item.departureDate,
          returnDate: item.returnDate,
          SendingProvince: item.departureOriginProvince || 'نامشخص',
          pilgrimMobileNumber: item.mobileNumber || '',
          departureType: item.departureType || '',
          returnType: item.returnType || '',
          departureOriginCity: item.departureOriginCity || '',
          departureOriginProvince: item.departureOriginProvince || ''
        });
      });
      setDataSet([...normalizedData]);
      setTotalItems(data.totalElements);
      setLoading(false);
    } catch (err: any) {
      if (err.message === 'cancel') {
        setLoading(true);
        return;
      }
      setError(err.message || EERRORS.ERROR_500);
      setLoading(false);
    }
  };

  useEffect(() => {
    getIt({...query});
    return () => {
      source.cancel('Operation canceled by the user.');
      setDataSet([]);
    };
  }, [query]);

  function handlePageChange(page: number = 1) {
    setQuery({...query, currentPage: page});
  }

  const [data, setData] = useState<any>(initialAddInqueryResponse);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const closeModal: () => void = () => {
    setIsOpen(false);
  };

  // const openModal: () => void = () => {
  //   setIsOpen(true);
  // };

  /* /api/v1/arbaeen/reports/qr-code/national-id/{nationalId} */
  return (
    <>
      <fieldset className="mb-2 rounded-xl border p-4 text-center">
        <legend className="text-black mx-auto px-3">لیست زائران</legend>
        <div className="align-center justify-spacebetween mb-8 flex space-x-5 rtl:space-x-reverse">
          <div className="align-center flex space-x-5 rtl:space-x-reverse">
            <div className="flex items-center">
              {/* <InquiryRequestButton/> */}
              <Filter
                userType
                provinceOption={provinceOptions}
                query={query}
                setQuery={setQuery}
              />
            </div>
          </div>
        </div>
        <div className="align-center flex w-full flex-col justify-center rounded-xl bg-white p-4 shadow">
          {error && !loading ? (
            <div className="p-40">
              <div className="text-red-500">{error}</div>
              <RetryButton setQuery={setQuery}/>
            </div>
          ) : (
            <Table
              loading={loading}
              handlePageChange={handlePageChange}
              dataSet={[...dataSet]}
              pagination={{pageSize, currentPage: query.currentPage}}
              totalItems={totalItems}
              columns={[
                {
                  name: 'نام و نام خانوادگی زائر',
                  key: 'pilgrimName',
                  render: (v: any, record, index: number) => (
                    <div className="flex w-full justify-start">
                      {toPersianDigit(
                        ((query.currentPage - 1) * pageSize + (index + 1)).toString()
                      )}
                      .{record.pilgrimName}
                    </div>
                  ),
                },
                {
                  name: 'کدملی زائر',
                  key: 'nationalId',
                  render: (v: any, record: any) => (
                    <span className="">
                      {record.nationalId ? toPersianDigit(record.nationalId) : '-'}
                    </span>
                  ),
                },
                {
                  name: 'مرز خروج',
                  key: 'exitBorder',
                },
                {
                  name: 'تاریخ اعزام',
                  key: 'dateOfDispatch',
                  render: (v: any, record: any) => (
                    <>
                      <div className="flex w-full justify-center">
                        <span className="text-gray-500 whitespace-normal ">
                          {record.dateOfDispatch ? (
                            toPersianDigit(
                              dayjs(record.dateOfDispatch).calendar('jalali').format('YYYY/MM/DD')
                            )
                          ) : (
                            <>-</>
                          )}
                        </span>
                      </div>
                    </>
                  ),
                },
                {
                  name: 'تاریخ بازگشت',
                  key: 'returnDate',
                  render: (v: any, record: any) => (
                    <>
                      <div className="flex w-full justify-center">
                        <span className="text-gray-500 whitespace-normal ">
                          {record.returnDate ? (
                            toPersianDigit(
                              dayjs(record.returnDate).calendar('jalali').format('YYYY/MM/DD')
                            )
                          ) : (
                            <>-</>
                          )}
                        </span>
                      </div>
                    </>
                  ),
                },

                {
                  name: 'استان اعزام',
                  key: 'SendingProvince',
                },
                {
                  name: 'شماره موبایل زائر',
                  key: 'pilgrimMobileNumber',
                  render: (v: any, record: any) => (
                    <span className="text-cyan-400">
                      {record.pilgrimMobileNumber
                        ? toPersianDigit(record.pilgrimMobileNumber)
                        : '-'}
                    </span>
                  ),
                },
                {
                  name: 'جزئیات',
                  key: 'details',
                  render: (v: any, record: any) => {
                    console.log('record => ', record)
                    return (
                      (
                        <span className="text-cyan-400 cursor-pointer"
                              onClick={() => {
                                setIsOpen(true)
                                setData(record)
                              }}
                        >
                      مشاهده
                    </span>
                      )
                    )
                  },
                },
              ]}
            />
          )}
        </div>
      </fieldset>
      {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        isOpen && <DetailModal isOpen={isOpen} closeModal={closeModal} data={data}/>
      }
    </>
  );
};
export default PilogrimListWithFiltering;


const DetailModal: React.FC<any> = ({isOpen, closeModal, data}) => {


  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={closeModal}>
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as="div"
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-opacity-90 bg-clip-padding backdrop-blur backdrop-filter"/>
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div
              className="relative my-8 inline-block w-full max-w-xl transform overflow-hidden rounded-2xl bg-white p-10 align-middle shadow-2xl transition-all">
              <Dialog.Title as="h3" className="my-4 font-bold leading-6 text-gray-900">
                <span> اطلاعات زائر با کد ملی:</span>
                <span className="px-1">
                    {data?.nationalId && toPersianDigit(`${data?.nationalId}`)}
                  </span>
              </Dialog.Title>

              <button
                type="button"
                className="absolute top-3 left-4 cursor-pointer text-gray-300"
                onClick={closeModal}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={3}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <div className="flex flex-col items-center justify-center   ">
                <div className=" mt-2 ">
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> نام و نام خانوادگی:</span>
                      <span className="px-1 font-semibold">
                          {data && data.pilgrimName ? data.pilgrimName : '-'}
                        </span>
                    </div>
                  </div>
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]">شماره موبایل:</span>
                      <span className="px-1 font-semibold">
                          {data?.pilgrimMobileNumber ? toPersianDigit(`${data?.pilgrimMobileNumber}`) : '-'}
                        </span>
                    </div>
                  </div>
                  <div
                    className=" items-center justify-center border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      {' '}
                      <span className="font-semibold text-[#AAA9A9]"> تاریخ عزیمت:</span>
                      {data?.dateOfDispatch ? (
                        <span className=" px-1 font-semibold">
                            {dayjs(data.dateOfDispatch)
                              .calendar('jalali')
                              .format('DD-MM-YYYY')
                              .toPersianDigits()}
                          </span>
                      ) : (
                        '-'
                      )}
                    </div>
                  </div>
                  <div
                    className=" items-center justify-center border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      {' '}
                      <span className="font-semibold text-[#AAA9A9]"> تاریخ برگشت:</span>
                      {data?.returnDate ? (
                        <span className=" px-1 font-semibold">
                            {dayjs(data.returnDate)
                              .calendar('jalali')
                              .format('DD-MM-YYYY')
                              .toPersianDigits()}
                          </span>
                      ) : (
                        '-'
                      )}
                    </div>
                  </div>
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> مرز خروجی:</span>
                      <span className="px-1 font-semibold">
                          {data && data.exitBorder
                            ? data.exitBorder
                            : '-'}
                        </span>
                    </div>
                  </div>
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> مرز ورودی:</span>
                      <span className="px-1 font-semibold">
                          {data && data.SendingProvince ? data.SendingProvince : '-'}
                        </span>
                    </div>
                  </div>
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> نوع عزیمت:</span>
                      <span className="px-1 font-semibold">
                          {data && data.departureType ? data.departureType : '-'}
                        </span>
                    </div>
                  </div>
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> نوع برگشت:</span>
                      <span className="px-1 font-semibold">
                          {data && data.returnType ? data.returnType : '-'}
                        </span>
                    </div>
                  </div>
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> شهر:</span>
                      <span className="px-1 font-semibold">
                          {data && data.departureOriginCity ? data.departureOriginCity : '-'}
                        </span>
                    </div>
                  </div>
                  {' '}
                  <div className=" border-b  border-gray-300 py-4 text-sm rtl:space-x-reverse">
                    <div>
                      <span className="font-semibold text-[#AAA9A9]"> استان:</span>
                      <span className="px-1 font-semibold">
                          {data && data.departureOriginProvince
                            ? data.departureOriginProvince
                            : '-'}
                        </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}